import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Interviews from "@/pages/Interviews";
import CommunityStories from "@/pages/CommunityStories";
import Events from "@/pages/Events";
import WorkWithCBJ from "@/pages/WorkWithCBJ";
import Contact from "@/pages/Contact";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { err: false };
    }
    static getDerivedStateFromError() {
        return { err: true };
    }
    render() {
        if (this.state.err) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-ink px-6 text-center">
                    <div>
                        <p className="font-script text-4xl text-neon-pink">
                            oops!
                        </p>
                        <p className="mt-3 text-fog">
                            Something went wrong. Refresh to check back in.
                        </p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { immediate: true });
        }
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollToTop />
                <div className="flex min-h-screen flex-col bg-ink">
                    <Navbar />
                    <main className="flex-1">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/interviews" element={<Interviews />} />
                            <Route
                                path="/community-stories"
                                element={<CommunityStories />}
                            />
                            <Route path="/events" element={<Events />} />
                            <Route
                                path="/work-with-cbj"
                                element={<WorkWithCBJ />}
                            />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="*" element={<Home />} />
                        </Routes>
                    </main>
                    <Footer />
                    <Toaster position="bottom-right" theme="dark" />
                </div>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
